import { Tooltip } from "react-tooltip";

export default function IconTooltip(props){
    return(
        <>
            <span className={'content-center cert-card pl-1'} data-tooltip-id={props.id} data-tooltip-content={props.name}>
                <img src={props.src} style={{width: props.width, height: props.height}} alt={props.id}/>
            </span>
            <Tooltip id={props.id}/>
        </>    
    )
}